<p-table #table     
    [value]="date_calendario" 
    responsiveLayout="stack" 
    [breakpoint]="'960px'"
    styleClass="p-datatable-striped" 
    [paginator]="true" 
    [showCurrentPageReport]="true" 
    [rowHover]="true" 
    showGridlines
    [globalFilterFields]="['data', 'orario']" 
    currentPageReportTemplate="{first} di {last} su {totalRecords} date" 
    [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-4 w-full">
            <div class="lg:w-3/4 w-full">
                <span class="block w-full p-input-icon-left">
                    <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
                    <input pInputText type="text" (input)="onGlobalFilter(table, $event)" placeholder="Cerca..." class="w-full indent-6" />
                </span>
            </div>
            <div class="lg:w-1/4 w-full">                    
                <button class="w-full h-full btn-outln-backoffice text-center" type="button" (click)="add = true">                
                    <i class="bi bi-plus"></i>
                    Aggiungi data calendario
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>           
            <th class="w-1/12"></th> 
            <th class="w-5/12">Data</th>
            <th class="w-4/12">Orario</th>
            <th class="w-2/12"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-calendario let-index="rowIndex">
        <tr [pReorderableRow]="index">   
            <td class="text-center">
                <i class="bi bi-list text-4xl hover:text-black" pReorderableRowHandle></i>
            </td>         
            <td>{{calendario.data | date: 'dd/MM/yyyy'}}</td>
            <td>{{calendario.orario}}</td>
            <td class="text-center">
                <div class="flex flex-row items-center justify-center">
                    <i class="bi bi-pencil text-2xl hover:text-black cursor-pointer" (click)="onOpenEdit(calendario)"></i>
                    <p-divider layout="vertical"></p-divider>
                    <ng-container *ngIf="calendario.id">
                        <p-confirmPopup #deleteCalendario>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                        <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnullaDelete()" label="Annulla" />
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash text-2xl hover:text-black cursor-pointer" (click)="onOpenDelete($event, calendario, index)"></i>    
                    </ng-container>
                    <ng-container *ngIf="!calendario.id">
                        <i class="bi bi-trash text-2xl hover:text-black cursor-pointer" (click)="date_calendario.splice(index, 1)"></i>
                    </ng-container>                    
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4">Nessuna data calendario presente.</td>
        </tr>
    </ng-template>
</p-table>

<!-- MODAL ADD/EDIT CALENDARIO -->
<p-dialog [visible]="(add || edit)" [style]="{width: '75%'}" [focusOnShow]="false" [header]="add ? 'Aggiungi data calendario' : 'Modifica data calendario'" [modal]="true" class="p-fluid" (visibleChange)="onCloseModal();">
    <ng-template pTemplate="content">

        <form [formGroup]="formCalendario">
            <div class="flex flex-col gap-8">
                <div class="flex lg:flex-row flex-col gap-8">
                    <div class="w-full">
                        <label>* Data</label>                                        
                        <p-calendar formControlName="data" dateFormat="dd/mm/yy" appendTo="body"  [showIcon]="true" />
                    </div>
                    <div class="w-full">
                        <label>Orario</label>
                        <p-calendar formControlName="orario" [timeOnly]="true" appendTo="body" [showIcon]="true" />
                    </div>
                </div>
                <div class="w-full flex lg:flex-row flex-col gap-4 justify-end">
                    <button type="button" class="btn-outln-backoffice p-3 px-8 font-medium" [disabled]="!formCalendario.valid" (click)="add ? onAdd(false) : onEdit()">{{add ? 'Aggiungi' : 'Modifica'}}</button>
                    <button type="button" class="btn-outln-backoffice p-3 px-8 font-medium" [disabled]="!formCalendario.valid" (click)="onAdd(true)" *ngIf="add">Aggiungi e continua a caricare</button>
                    <button type="button" class="btn-danger-backoffice p-3 px-8 font-medium" (click)="onCloseModal()">Annulla</button>
                </div>                
            </div>
        </form>
        
    </ng-template>
</p-dialog>
<!-- MODAL ADD/EDIT CALENDARIO -->